import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { User, UserObject } from '@digital-platform/people/domain';

@Injectable({
  providedIn: 'root',
})
export class PeopleService {
  constructor(private readonly httpClient: HttpClient) {}

  public searchInternalUser(
    query: Record<string, string>
  ): Observable<UserObject[]> {
    return this.httpClient.get<UserObject[]>(
      `api/people/search-internal-user?${Object.keys(query)
        .map((k) => `${k}=${query[k]}`)
        .join('&')}`
    );
  }

  public updateInternalUser(payload: any): any {
    const url = 'api/people/update-internal-user';
    return this.httpClient.patch<any>(url, payload).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }

  public getCoordinators(): Observable<User[]> {
    const url = 'api/people/coordinators';
    return this.httpClient.get<User[]>(url).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }
  public getSalesReps(): Observable<User[]> {
    const url = 'api/people/sales-reps';
    return this.httpClient.get<User[]>(url).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }
  public getAnalysts(): Observable<User[]> {
    const url = 'api/people/analysts';
    return this.httpClient.get<User[]>(url).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }

  public createSalesRep(userObject: UserObject): Observable<UserObject> {
    const url = 'api/people/sales-rep-new';
    const body = userObject;
    return this.httpClient.post<UserObject>(url, body).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }

  public createCoordinator(userObject: UserObject): Observable<UserObject> {
    const url = 'api/people/coordinator-new';
    const body = userObject;
    return this.httpClient.post<UserObject>(url, body).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }

  public createAnalyst(userObject: UserObject): Observable<UserObject> {
    const url = 'api/people/analyst-new';
    const body = userObject;
    return this.httpClient.post<UserObject>(url, body).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(error);

      switch (error.status) {
        case 403:
          return throwError(
            'Access denied while loading People, please try again later or contact Republic Services'
          );
      }
    }

    let message = 'Something bad happened; please try again later.';

    if (error.error.message) {
      message = error.error.message;
    }

    // Return an observable with a user-facing error message.
    return throwError(message);
  }
}
